import { Page } from "./page";
import { PageContent } from "./pageContent";

export class ExportContent {
    public page: Array<Page> = new Array<Page>();
    public content: Array<PageContent> = new Array<PageContent>();
}



// WEBPACK FOOTER //
// ./src/app/shared/models/ExportContent.ts